module.exports = __webpack_public_path__ + "static/media/menu.d2e11144.jpeg";